import { on } from "svelte/events";
import { findScrollingElement } from "../../utils/findContainingElement";
import { PositionObserver } from "./PositionObserver";

export const attachPositioningEventListeners = (
  containingElement: HTMLElement,
  contextElement: HTMLElement,
  onPositionChange: () => void,
): (() => void) => {
  if (!containingElement) return () => {};
  /*                                                                      */
  const scrollWindowRemove = on(window, "scroll", onPositionChange, { passive: true });
  const resizeWindowRemove = on(window, "resize", onPositionChange, { passive: true });
  const positionObserver = contextElement
    ? new PositionObserver(contextElement, () => {
        onPositionChange();
      })
    : null;
  const removeWindowListeners = (): void => {
    scrollWindowRemove();
    resizeWindowRemove();
    positionObserver?.disconnect();
  };

  /*                                       */
  const clippingElement = findScrollingElement(containingElement);
  if (clippingElement) {
    const scrollClippingRemove = on(clippingElement, "scroll", onPositionChange, { passive: true });
    const resizeObserver = new ResizeObserver(onPositionChange);
    resizeObserver.observe(clippingElement);

    return () => {
      scrollClippingRemove();
      resizeObserver.disconnect();
      removeWindowListeners();
    };
  }
  return removeWindowListeners;
};
